<script setup lang="ts">
import { onMounted } from 'vue'

const props = defineProps({
  widgetId: {
    type: String,
    required: true,
  },
})

onMounted(() => {
  if (document.getElementById('raychat-script')) return

  window.RAYCHAT_TOKEN = props.widgetId

  const script = document.createElement('script')
  script.id = 'raychat-script'
  script.src = 'https://widget-react.raychat.io/install/widget.js'
  script.async = true

  document.head.appendChild(script)
})
</script>

<template>
  <!-- Raychat injects its own UI -->
  <div></div>
</template>
